import { Component } from 'react'
import * as cn from 'classnames'
import { getNamedChildrenRenderer, getChildWithType } from 'tangle-shared'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { isMobileSelector } from 'selectors/viewportSelectors'
import * as styles from 'styles/layouts/HeadedChartLayout.css'

type HeadedChartLayoutStateProps = {
  isMobile: boolean
}

type HeadedChartLayoutOwnProps = {
  fullHeight?: boolean
}

type HeadedChartLayoutProps =
  & HeadedChartLayoutStateProps
  & HeadedChartLayoutOwnProps

export class HeadedChartLayoutComponent extends Component<HeadedChartLayoutProps> {
  static HeaderMarker = getNamedChildrenRenderer('HeaderMarker')
  static ChartMarker = getNamedChildrenRenderer('ChartMarker')
  static LegendMarker = getNamedChildrenRenderer('LegendMarker')
  static PreloaderMarker = getNamedChildrenRenderer('PreloaderMarker')

  render () {
    const { isMobile, fullHeight } = this.props

    const boundGetChildWithType = getChildWithType.bind(null, this.props.children)

    const chart = boundGetChildWithType(HeadedChartLayoutComponent.ChartMarker)
    const header = boundGetChildWithType(HeadedChartLayoutComponent.HeaderMarker)
    const legend = boundGetChildWithType(HeadedChartLayoutComponent.LegendMarker)
    const preloader = boundGetChildWithType(HeadedChartLayoutComponent.PreloaderMarker)

    const className = cn(styles.headedChartLayout, {
      [styles.isMobile]: isMobile,
      [styles.fullHeight]: fullHeight,
    })

    return (
      <div className={ className }>
        {
          Boolean(preloader) && (
            <div className={ styles.preloader }>
              { preloader }
            </div>
          )
        }
        {
          Boolean(header) && (
            <div className={ styles.header }>
              { header }
            </div>
          )
        }
        {
          Boolean(chart) && (
            <div className={ styles.chartWrapper }>
              <div className={ styles.chart }>
                { chart }
              </div>
            </div>
          )
        }
        {
          Boolean(legend) && (
            <div className={ styles.legend }>
              { legend }
            </div>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = createSelector(
  isMobileSelector,
  (isMobile) => ({
    isMobile,
  })
)

const HeadedChartLayout = connect<HeadedChartLayoutStateProps, {}, HeadedChartLayoutOwnProps>(mapStateToProps)(HeadedChartLayoutComponent)

export default HeadedChartLayout
